.externalIcon::after {
    content: " \2197";  /* ↗ */
    font-size: 0.75em;
    vertical-align: super;
    line-height: 0;
}
